import { Modal, Form, Input, Checkbox , Row, Col} from 'antd';
import { useState, useEffect } from 'react';
import { MyButton, MyText } from '../common';
import { StyledCheckbox } from './ConsulationPopup/style';
import {useTranslation} from "react-i18next";

interface ConsultationFormModalProps {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
  selectedItem: any, 
}

export const ResultPopup: React.FC<ConsultationFormModalProps> = ({ visible, onOk, onCancel, selectedItem }) => {
  const [form] = Form.useForm();
  const {t} = useTranslation("common")
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
    anonymous: false,
  });
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  useEffect(() => {
    const { name, phone, email, message } = formData;
    const isFormComplete = name && phone && email && message;
    setIsButtonDisabled(!isFormComplete);
  }, [formData]);


  return (
    <Modal
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={null}
      centered
      width={1059}
    >
      <MyText color='#0A033C' size={32} weight={800} style={{ fontFamily: 'Nunito' }}>
        Ответ специалиста
      </MyText>
      <Form form={form} layout="vertical" name="consultationForm" style={{marginTop: 20}}>
      <MyText color='rgba(19, 15, 38, 1)' size={14} weight={600} style={{ fontFamily: 'Nunito' }}>
        <div
          style={{ fontFamily: 'Nunito', lineHeight: '16px',fontSize: '16px' }}
          dangerouslySetInnerHTML={{ __html: selectedItem?.recommendation }}
        />
      </MyText>
      </Form>
    </Modal>
  );
};
